import { all, takeLatest } from "redux-saga/effects";
import { Action } from "redux";
import meta from "./meta";

export const initAction: Action = { type: "__APP_INIT__" };

export function* initSaga() {
  yield takeLatest(initAction.type, initiaization);
}

function* initiaization() {
  yield all([meta()]);
}
